import { render, staticRenderFns } from "./AnnouncementAdd.vue?vue&type=template&id=6d12c725"
import script from "./AnnouncementAdd.vue?vue&type=script&lang=js"
export * from "./AnnouncementAdd.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementAdd.vue?vue&type=style&index=0&id=6d12c725&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports